import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  loginAt: "",
  expireAt: "",
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    addUser(state, action) {
      state.user = action.payload;
    },
    setLoginAt(state, action) {
      state.loginAt = action.payload;
    },
    setExpireAt(state, action) {
      state.expireAt = action.payload;
    },
    updateSubscriptionId(state, action) {
      state.user.subscription_id = action.payload;
    },
  },
});

export const { addUser, setLoginAt, setExpireAt, updateSubscriptionId } = loginSlice.actions;
export default loginSlice.reducer;
